export const NAME = "chatMessages"
export const FIREBASE_PATH = "chatMessages"
